import { Location } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { Breadcrumb } from 'primeng/breadcrumb';
import { distinctUntilChanged, filter, map, startWith } from 'rxjs/operators';

@Component({
  selector: 'vnm-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent extends Breadcrumb {
  @Input() separatorIcon = 'fa fa-fw fa-angle-right';

  model$ = this.router.events.pipe(
    filter((event) => event instanceof NavigationEnd),
    distinctUntilChanged(),
    startWith(1), // Don't actually care about the value, just need to start
    map(() => this.createMenuItem(this.route.root))
  );

  constructor(private router: Router, public route: ActivatedRoute, private location: Location) {
    super();
  }

  createMenuItem(route: ActivatedRoute, url: string = '', breadcrumbs: MenuItem[] = []): MenuItem[] {
    const label = route.routeConfig ? route.routeConfig.data?.breadcrumb : '';
    const path = route.snapshot.url.join('/');

    if (label === false) {
      return breadcrumbs;
    }

    const nextUrl = `${url}${path}/`;
    const breadcrumb: MenuItem = {
      label: label,
      routerLink: nextUrl
    };

    if (label === '') {
      breadcrumb.icon = 'fa fa-fw fa-home';
    } else {
      breadcrumb.label = label;
    }

    let newBreadcrumbs = [...breadcrumbs, breadcrumb];
    if (route.firstChild) {
      return this.createMenuItem(route.firstChild, nextUrl, newBreadcrumbs);
    }

    const backData = route.routeConfig?.data?.back;
    if (backData) {
      const backItem = {
        icon: 'fa fa-fw fa-arrow-left',
        styleClass: 'back-nav',
        command: (_) => {
          if (backData === true) {
            this.location.back();
          } else if (backData) {
            this.router.navigate([backData], { relativeTo: route });
          }
        }
      };

      newBreadcrumbs = [backItem, ...newBreadcrumbs];
    }

    return newBreadcrumbs;
  }
}
